import React, { useState } from 'react';
import { useHotkeys } from 'react-hotkeys-hook';
import { useSelector } from 'react-redux';
import AppNavDrawer from '../AppNavDrawer';
import AppBar from '../AppBar';
import {
  getIsFetchingConfigs,
  getIsFetchingGlobalConfigs
} from '../../features/app/selectors';
import ProgressFullscreen from '../common/ProgressFullscreen';

const AppContainer = ({ children }) => {
  const [showNavDrawer, setShowNavDrawer] = useState(false);
  const isFetchingConfigs = useSelector(getIsFetchingConfigs);
  const isFetchingGlobalConfigs = useSelector(getIsFetchingGlobalConfigs);
  const isFetching = isFetchingConfigs || isFetchingGlobalConfigs;

  const toggleNavDrawer = () => {
    setShowNavDrawer(isOpen => {
      if (isFetching) {
        return false;
      }
      return !isOpen;
    });
  };
  useHotkeys('m', toggleNavDrawer, {}, [isFetching]);

  return (
    <>
      <AppNavDrawer toggleNavDrawer={toggleNavDrawer} open={showNavDrawer} />
      <main>
        <AppBar toggleNavDrawer={toggleNavDrawer} />
        {isFetching ? <ProgressFullscreen /> : children}
      </main>
    </>
  );
};

export default AppContainer;
